import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodOptionalId, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminTasksRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/admin_tasks',
  validateSearch: z.object({
    page: zodPage,
    tab: z.enum(['pending', 'done', 'archived']).default('pending'),
    assignedUserId: zodOptionalId,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/admin/AdminTasks/AdminTasksPage/AdminTasksPage').then((d) => d.Route));
